import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import Box from '../box/box.jsx';
import styles from './blocks.css';

const BlocksComponent = props => {
    const {
        colorMode,
        containerRef,
        dragOver,
        ...componentProps
    } = props;
    void colorMode;
    return (
        <Box
            className={classNames(styles.blocks, {
                [styles.dragOver]: dragOver
            })}
            {...componentProps}
            componentRef={containerRef}
        />
    );
};
BlocksComponent.propTypes = {
    colorMode: PropTypes.string,
    containerRef: PropTypes.func,
    dragOver: PropTypes.bool
};
export default BlocksComponent;
